import React from 'react';
import YouTube, { YouTubeEvent, YouTubePlayer, YouTubeProps } from 'react-youtube';

const campaignName = 'Bumble Night In video from ';

type PageVideoBlockPropsType = {
    videoId: string | null;
};

const PageVideoBlock = (props: PageVideoBlockPropsType) => {
    const opts = {
        height: '100%',
        width: '100%',
        playerVars: {
            // @TODO: perhaps use playlist to play videos - https://developers.google.com/youtube/player_parameters
            autoplay: 1,
            loop: 1,
            controls: 0,
            playsinline: 1,
            mute: 1,
            color: 'white',
            rel: 0,
            iv_load_policy: 3,
            disablekb: 1,
            fs: 0,
        },
    };

    const onReadyHandler = (event: any) => {
        if (props.videoId) {
            event.target.mute();
            event.target.playVideo();
        }
        // hide for now
        // if (global.window.ga) {
        //     global.window.ga('set', 'location', global.window.location.href);
        //     global.window.ga(
        //         'send',
        //         'event',
        //         campaignName + global.window.location.href,
        //         'load',
        //         campaignName + global.window.location.href,
        //         {
        //             nonInteraction: true,
        //         }
        //     );
        // }
        // setPlayer(event.target);
    };
    const onStateChangeHadler = (event: YouTubeEvent<number>) => {
        if (global.window.ga) {
            global.window.ga(
                'send',
                'event',
                campaignName + global.window.location.href,
                event.data,
                campaignName + global.window.location.href,
            );
        }
    };
    const onEndHandler = ({ target }: { target: YouTubePlayer }) => {
        target.mute();
        target.playVideo();
        // hide for now
        // if (global.window.ga) {
        //     global.window.ga('set', 'location', global.window.location.href);
        //     global.window.ga(
        //         'send',
        //         'event',
        //         campaignName + global.window.location.href,
        //         'load',
        //         campaignName + global.window.location.href,
        //         {
        //             nonInteraction: true,
        //         }
        //     );
        // }
    };

    return (
        <div className="media-box-youtube-wrapper">
            <div className="media-box-youtube-wrapper__mock" />
            {props.videoId ? (
                <YouTube
                    videoId={props.videoId}
                    className="media-box-youtube has-shadow"
                    iframeClassName="media-box-youtube__frame"
                    title={campaignName}
                    loading="lazy"
                    opts={opts as YouTubeProps['opts']}
                    onReady={onReadyHandler}
                    onStateChange={onStateChangeHadler}
                    onEnd={onEndHandler}
                />
            ) : null}
        </div>
    );
};

export { PageVideoBlock };
